<template>
  <div>
    <div class="card border-primary mx-auto" style="max-width: 100%">
      <div class="card-body">
        <a-alert
          class="mb-2"
          :message="
            $t('cantine.dateChoisie') +
            `: ${selectedValue && selectedValue.format('DD/MM/YYYY')}`
          "
        />
        <div class="row">
          <div class="col-xl-4 col-lg-4">
            <div class="card">
              <div class="card-header">
                {{ $t("cantine.choisirDate") }}
              </div>
              <div class="card-body">
                <div
                  :style="{
                    border: '1px #d9d9d9',
                    borderRadius: '4px',
                  }"
                >
                  <a-calendar
                    :value="value"
                    @select="onSelect"
                    @panelChange="onPanelChange"
                    :fullscreen="false"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-8">
            <a-row :gutter="8" class="mb-2">
              <a-col :span="12">
                <a-tooltip placement="top">
                  <template slot="title">
                    {{ $t("cantine.ajouterRepas") }}
                  </template>

                  <a-button
                    type="primary"
                    icon="search"
                    style="width: 100%"
                    @click="showDrawer('add')"
                  >
                    {{ $t("cantine.ajouterRepas") }}
                  </a-button>
                </a-tooltip>
              </a-col>
              <a-col :span="12">
                <a-button
                  icon="calendar"
                  style="width: 100%"
                  @click="openWeeklyMenuDrawer()"
                >
                  {{ $t("cantine.ajouterMenuHebdo") }}
                </a-button>
              </a-col>
            </a-row>
            <div class="card">
              <div class="card-body pt-2">
                <a-tabs v-model="activeTab">
                  <a-tab-pane key="menus">
                    <span slot="tab">
                      <a-icon type="calendar" />
                      {{ $t("cantine.menusHebdo") }}
                      <a-icon v-if="loadingWeeklyMenus" type="loading" />
                      <template v-else>
                        ({{ filteredWeeklyMenus.length }})
                      </template>
                    </span>
                    <WeeklyMenuList
                      :menus="filteredWeeklyMenus"
                      :loading="loadingWeeklyMenus"
                      @edit="openWeeklyMenuDrawer"
                      @delete="deleteWeeklyMenu"
                    />
                  </a-tab-pane>
                  <a-tab-pane key="meals">
                    <span slot="tab">
                      <a-icon type="coffee" />
                      {{ $t("cantine.repasDuJour") }}
                      <a-icon v-if="loadingMeals" type="loading" />
                      <template v-else>({{ filtredData.length }})</template>
                    </span>
                    <MealList
                      :meals="filtredData"
                      :loading="loadingMeals"
                      @edit="editItem"
                      @delete="deleteItem"
                    />
                  </a-tab-pane>
                </a-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-drawer
      :title="
        $t('cantine.ajouterNewMenu', {
          date: selectedValue.format('YYYY-MM-DD'),
        })
      "
      :width="720"
      :visible="addDrawer"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose('add')"
    >
      <a-form :form="addForm" layout="vertical">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item :label="$t('cantine.mealName')">
              <a-input
                v-decorator="[
                  'Name',
                  {
                    rules: [{ required: true, message: $t('requis.repas') }],
                  },
                ]"
                :placeholder="$t('requis.repas')"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item :label="$t('cantine.type')">
              <a-select
                v-decorator="[
                  'category',
                  {
                    rules: [
                      { required: false, message: $t('cantine.saisirType') },
                    ],
                  },
                ]"
                :placeholder="$t('cantine.saisirType')"
              >
                <a-select-option value="dessert">
                  {{ $t("cantine.dessert") }}
                </a-select-option>
                <a-select-option value="platP">
                  {{ $t("cantine.plat") }}
                </a-select-option>
                <a-select-option value="entree">
                  {{ $t("cantine.entree") }}
                </a-select-option>
                <a-select-option value="goute">
                  {{ $t("cantine.goute") }}
                </a-select-option>
                <a-select-option value="boissons">
                  {{ $t("cantine.boissons") }}
                </a-select-option>
                <a-select-option value="autre">
                  {{ $t("cantine.autre") }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="$t('cantine.repeter')">
              <a-select
                v-decorator="[
                  'repeat.days',
                  {
                    rules: [
                      {
                        required: false,
                        message: $t('cantine.choisirJour'),
                      },
                    ],
                  },
                ]"
                v-model="repeat"
                mode="multiple"
                :placeholder="$t('cantine.choisirJour')"
              >
                <a-select-option :value="1">
                  {{ moment().day(1).format("dddd") }}
                </a-select-option>
                <a-select-option :value="2">
                  {{ moment().day(2).format("dddd") }}
                </a-select-option>
                <a-select-option :value="3">
                  {{ moment().day(3).format("dddd") }}
                </a-select-option>
                <a-select-option :value="4">
                  {{ moment().day(4).format("dddd") }}
                </a-select-option>
                <a-select-option :value="5">
                  {{ moment().day(5).format("dddd") }}
                </a-select-option>
                <a-select-option :value="6">
                  {{ moment().day(6).format("dddd") }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="repeat && repeat.length > 0">
            <a-form-item :label="$t('all.endDate')">
              <a-date-picker
                format="DD/MM/YYYY"
                v-decorator="[
                  'repeat.endDate',
                  {
                    rules: [
                      { required: true, message: $t('cantine.saisirEndDate') },
                    ],
                  },
                ]"
                :placeholder="$t('cantine.saisirEndDate')"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="24">
            <a-upload-dragger
              v-decorator="[
                'photo',
                {
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :multiple="false"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :customRequest="addTofileList"
              list-type="picture"
              @change="handleChangeUpload"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="file-image" />
              </p>
              <p class="ant-upload-text">
                {{ $t("etablissement.clickOrDragToUpload") }}
              </p>
            </a-upload-dragger>
          </a-col>
        </a-row>
      </a-form>
      <a-progress
        :stroke-color="{
          from: '#108ee9',
          to: '#87d068',
        }"
        v-if="progress.value > 0"
        :percent="progress.value"
        status="active"
      />
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button
          :style="{ marginRight: '8px' }"
          @click="onClose('add')"
          :disabled="loadingAddBtn"
        >
          {{ $t("action.annuler") }}
        </a-button>
        <a-button
          type="primary"
          @click="handleSubmit"
          :loading="loadingAddBtn"
          :disabled="loadingAddBtn"
        >
          {{ $t("action.ajouter") }}
        </a-button>
      </div>
    </a-drawer>

    <!-- UPDATE DRAWER -->
    <a-drawer
      v-if="selectedMenu"
      :title="$t('cantine.modifierMenu', { name: selectedMenu.name })"
      :width="720"
      :visible="updateDrawer"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose('update')"
    >
      <a-form :form="form" layout="vertical">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item :label="$t('cantine.mealName')">
              <a-input
                v-decorator="[
                  'Name',
                  {
                    initialValue: selectedMenu.name,
                    rules: [{ required: true, message: $t('requis.repas') }],
                  },
                ]"
                initialValue="record.name"
                :placeholder="$t('requis.repas')"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item :label="$t('cantine.type')">
              <a-select
                v-decorator="[
                  'category',
                  {
                    initialValue: selectedMenu.category,
                    rules: [
                      { required: false, message: $t('cantine.saisirType') },
                    ],
                  },
                ]"
                :placeholder="$t('cantine.saisirType')"
              >
                <a-select-option value="dessert">
                  {{ $t("cantine.dessert") }}
                </a-select-option>
                <a-select-option value="platP">
                  {{ $t("cantine.plat") }}
                </a-select-option>
                <a-select-option value="entree">
                  {{ $t("cantine.entree") }}
                </a-select-option>
                <a-select-option value="goute">
                  {{ $t("cantine.goute") }}
                </a-select-option>
                <a-select-option value="boissons">
                  {{ $t("cantine.boissons") }}
                </a-select-option>
                <a-select-option value="autre">
                  {{ $t("cantine.autre") }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="$t('cantine.repeter')">
              <a-select
                v-decorator="[
                  'repeat.days',
                  {
                    initialValue:
                      selectedMenu.repeat && selectedMenu.repeat.days
                        ? selectedMenu.repeat.days
                        : [],
                    rules: [
                      {
                        required: false,
                        message: $t('cantine.choisirJour'),
                      },
                    ],
                  },
                ]"
                v-model="selectedMenu.repeat.days"
                mode="multiple"
                :placeholder="$t('cantine.choisirJour')"
              >
                <a-select-option :value="1">
                  {{ moment().day(1).format("dddd") }}
                </a-select-option>
                <a-select-option :value="2">
                  {{ moment().day(2).format("dddd") }}
                </a-select-option>
                <a-select-option :value="3">
                  {{ moment().day(3).format("dddd") }}
                </a-select-option>
                <a-select-option :value="4">
                  {{ moment().day(4).format("dddd") }}
                </a-select-option>
                <a-select-option :value="5">
                  {{ moment().day(5).format("dddd") }}
                </a-select-option>
                <a-select-option :value="6">
                  {{ moment().day(6).format("dddd") }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col
            :span="12"
            v-if="
              selectedMenu &&
              selectedMenu.repeat &&
              selectedMenu.repeat.days &&
              selectedMenu.repeat.days.length > 0
            "
          >
            <a-form-item :label="$t('all.endDate')">
              <a-date-picker
                format="DD/MM/YYYY"
                v-decorator="[
                  'repeat.endDate',
                  {
                    initialValue: selectedMenu.repeat.endDate,
                    rules: [
                      { required: true, message: $t('cantine.saisirEndDate') },
                    ],
                  },
                ]"
                :placeholder="$t('cantine.saisirEndDate')"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-upload-dragger
              v-decorator="[
                'photo',
                {
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :multiple="false"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :customRequest="addTofileList"
              list-type="picture"
              @change="handleChangeUpload"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="file-image" />
              </p>
              <p class="ant-upload-text">
                {{ $t("etablissement.clickOrDragToUpload") }}
              </p>
            </a-upload-dragger>
          </a-col>
        </a-row>
      </a-form>
      <a-progress
        :stroke-color="{
          from: '#108ee9',
          to: '#87d068',
        }"
        v-if="progress.value > 0"
        :percent="progress.value"
        status="active"
      />
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button
          :style="{ marginRight: '8px' }"
          @click="onClose('update')"
          :disabled="loadingUpdateBtn"
        >
          {{ $t("action.annuler") }}
        </a-button>
        <a-button
          type="primary"
          @click="handleUpdate"
          :loading="loadingUpdateBtn"
          :disabled="loadingUpdateBtn"
        >
          {{ $t("action.modifier") }}
        </a-button>
      </div>
    </a-drawer>

    <WeeklyMenuDrawer
      :visible="weeklyMenuDrawer"
      :menu="editingWeeklyMenu"
      @close="weeklyMenuDrawer = false"
      @saved="getWeeklyMenus"
    />
  </div>
</template>
<script>
import apiClient from "@/services/axios";
import { mapState } from "vuex";
import { uploadFilesToS3 } from "@/services/uploadService";

import moment from "moment";
import WeeklyMenuDrawer from "./components/WeeklyMenuDrawer.vue";
import WeeklyMenuList from "./components/WeeklyMenuList.vue";
import MealList from "./components/MealList.vue";

export default {
  components: { WeeklyMenuDrawer, WeeklyMenuList, MealList },
  data() {
    return {
      loading: false,
      loadingMeals: true,
      loadingWeeklyMenus: true,
      data: [],
      value: moment(),
      selectedValue: moment(),
      selectedMenu: null,
      form: this.$form.createForm(this),
      addForm: this.$form.createForm(this),
      addDrawer: false,
      updateDrawer: false,
      repeat: [],
      fileList: [],
      loadingAddBtn: false,
      loadingUpdateBtn: false,
      progress: { value: 0 },
      cantinePhoto: null,
      deleteFile: false,
      weeklyMenuDrawer: false,
      weeklyMenus: [],
      activeTab: "menus",
      editingWeeklyMenu: null,
    };
  },
  methods: {
    openWeeklyMenuDrawer(menu = null) {
      this.editingWeeklyMenu = menu;
      this.weeklyMenuDrawer = true;
    },
    getWeeklyMenus() {
      this.loadingWeeklyMenus = true;
      apiClient
        .get("/weeklyMenu")
        .then((res) => {
          this.weeklyMenus = res.data;
        })
        .catch((e) => console.log(e))
        .finally(() => {
          this.loadingWeeklyMenus = false;
        });
    },
    deleteWeeklyMenu(menu) {
      apiClient
        .delete(`/weeklyMenu/${menu._id}`)
        .then(() => {
          this.$message.success(this.$t("cantine.menuHebdoSupprime"));
          this.getWeeklyMenus();
        })
        .catch(() => {
          this.$message.error(this.$t("cantine.erreurSuppressionMenuHebdo"));
        });
    },
    moment,
    onSelect(value) {
      this.value = value;
      this.selectedValue = value;
    },
    onPanelChange(value) {
      this.value = value;
    },
    showDrawer(type) {
      if (type == "add") {
        this.fileList = [];
        this.addForm.resetFields();
        this.addDrawer = true;
      } else if (type == "update") {
        this.cantinePhoto = null;
        this.deleteFile = false;
        this.form.resetFields();
        this.updateDrawer = true;
      }
    },
    onClose(type) {
      if (type == "add") this.addDrawer = false;
      if (type == "update") this.updateDrawer = false;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.addForm.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.loadingAddBtn = true;
            values.date = this.value;
            const data = {};
            if (values.Name) data.name = values.Name;
            if (values.category) data.category = values.category;
            if (values.date) data.date = values.date;
            if (values.repeat) data.repeat = JSON.stringify(values.repeat);
            if (this.cantinePhoto) {
              const uploadedKeys = await uploadFilesToS3(
                [this.cantinePhoto],
                "manager/canteen",
                this.progress
              );
              data.file = uploadedKeys[0];
            }
            await apiClient({
              method: "put",
              url: "/cantine",
              data,
            });
            this.getAllFood();
            this.onClose("add");
            this.$message.success(this.$t("cantine.addSuccessMessage"));
          } catch (e) {
            this.$message.error(this.$t("cantine.errorMessageAdd"));
          } finally {
            this.loadingAddBtn = false;
            this.progress = { value: 0 };
            this.fileList = [];
            this.cantinePhoto = null;
          }
        }
      });
    },
    handleUpdate(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.loadingUpdateBtn = true;
            values.date = this.value;
            const data = {};
            if (values.Name) data.name = values.Name;
            if (values.category) data.category = values.category;
            if (values.date) data.date = values.date;
            if (values.repeat) data.repeat = JSON.stringify(values.repeat);
            if (this.deleteFile) data.oldFile = this.selectedMenu.file;
            if (this.cantinePhoto) {
              const uploadedKeys = await uploadFilesToS3(
                [this.cantinePhoto],
                "manager/canteen",
                this.progress
              );
              data.file = uploadedKeys[0];
            }
            if (this.deleteFile && !this.cantinePhoto) data.file = "";
            await apiClient({
              method: "patch",
              url: "/cantine/" + this.selectedMenu._id,
              data,
            });

            this.getAllFood();
            this.onClose("update");
            this.$message.success(this.$t("cantine.editSuccessMessage"));
          } catch (e) {
            this.$message.error(this.$t("cantine.errorMessage"));
          } finally {
            this.loadingUpdateBtn = false;
            this.progress = { value: 0 };
            this.fileList = [];
            this.cantinePhoto = null;
          }
        }
      });
    },
    //Update food
    editItem(item) {
      this.selectedMenu = {
        ...item,
        repeat: item.repeat || { days: [], endDate: null },
      };
      if (item.file) {
        this.fileList = [
          {
            uid: "-1",
            name: item.file.split("/").pop(), // Get the filename from the path
            status: "done",
            url: this.settings.resourcesUrl.replace("FILE_PATH", item.file),
          },
        ];
      } else {
        this.fileList = [];
      }
      this.showDrawer("update");
    },
    //Delete food
    deleteItem(item) {
      apiClient
        .delete("/cantine/" + item._id, { data: { file: item.file } })
        .then((res) => {
          this.getAllFood();
        })
        .catch((e) => console.log(e));
    },
    //Get all foods
    getAllFood() {
      this.loadingMeals = true;
      apiClient
        .post("/cantine/filter", { query: {} })
        .then((res) => {
          this.data = res.data;
        })
        .catch((e) => console.log(e))
        .finally(() => {
          this.loadingMeals = false;
        });
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error(this.$t("error.fichiers"));
      }
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error(this.$t("error.image"));
      }
      if (isJpgOrPng && isLt2M) {
        this.$message.success(
          this.$t("success.imageTelecharge", { name: file.name })
        );
        this.cantinePhoto = file;
      }
      return isJpgOrPng && isLt2M;
    },
    addTofileList() {
      this.fileList = [
        {
          uid: "-1",
          name: this.cantinePhoto.name,
          status: "done",
          url: URL.createObjectURL(this.cantinePhoto),
        },
      ];
      this.deleteFile = true;
    },
    handleChangeUpload(info) {
      const { status } = info.file;
      if (status === "removed") {
        this.deleteFile = true;
        this.cantinePhoto = null;
        this.fileList = [];
      }
    },
  },
  computed: {
    ...mapState(["settings"]),
    filteredWeeklyMenus() {
      const day = this.value.day();
      return this.weeklyMenus.filter((menu) => {
        if (!this.value.isBetween(menu.startDate, menu.endDate, "day", "[]"))
          return false;
        if (day === 6) return menu.includeSaturday;
        if (day === 0) return menu.includeSunday;
        return true;
      });
    },
    filtredData() {
      let data = this.data.filter(
        (food) =>
          moment(food.date).format("YYYYDDMM") == this.value.format("YYYYDDMM")
      );
      let repeats = this.data.filter((food) => {
        return (
          food.repeat &&
          this.value.isSameOrBefore(moment(food.repeat.endDate), "day") &&
          this.value.isSameOrAfter(moment(food.createdAt), "day") &&
          food.repeat.days.includes(this.value.day())
        );
      });

      repeats = repeats.concat(data);

      return [...new Set(repeats)];
    },
  },
  created() {
    // Get all foods
    this.getAllFood();
    this.getWeeklyMenus();
  },
};
</script>
